import {FieldArray, Form, Formik} from 'formik'
import {isEmpty} from 'lodash'
import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {toast} from 'react-toastify'
import * as Yup from 'yup'

import {StateParamsModel} from 'src/app/modules/common/Model'
import * as contactPersonRedux from '../index'

import Modal from 'rsuite/Modal'

import checkMultiLanguage from 'src/app/modules/common/checkMultiLanguage'
import {IDepartmentState} from 'src/app/modules/userMgmt/components/departments'
import FormInputMediaManager from 'src/cms/helpers/components/forms/FormInputMediaManager'
import FormSelect from 'src/cms/helpers/components/forms/FormSelect'
import FormTextBox from 'src/cms/helpers/components/forms/FormTextBox'
import {imageBaseUrl} from 'src/cms/helpers/constants'
import * as departments from '../../../../userMgmt/components/departments'

type Props = {
  open: boolean
  params?: StateParamsModel
  handleClose: () => void
  actionType: string
  editSelectedData?: any
}
const FORM_VALIDATION = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .nullable(),
  // phone_numbers: Yup.array().of(
  //   Yup.object().shape({
  //     data: Yup.string()
  //       .matches(/^[0-9][0-9 -]*$/, 'Enter valid mobile number')
  //       .max(10, 'Phone number should not exceed 10 digits')
  //       .nullable(),
  //   })
  // ),
  email2: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .nullable(),
  mobile_numbers: Yup.array().of(
    Yup.object().shape({
      data: Yup.string()
        .matches(/^(98|97)([0-9]{8})$/, 'Enter valid mobile number')
        .max(10, 'Mobile number should not exceed 10 digits'),
    })
  ),
  designation: Yup.string().required('Designation is required'),
  // .matches(/^[A-Za-z\s &]+$/, 'Must not contain number or symbol'),
})
const AddContactPerson = ({open, params, handleClose, actionType, editSelectedData}: Props) => {
  const dispatch = useDispatch()
  const {loading, success} = useSelector((state: any) => state.contactPerson)
  const departmentData: IDepartmentState = useSelector((state: any) => state.departments)

  // const departmentDropdownData = useSelector((state) => state.departments)

  const departmentOptions = departmentData?.data?.department?.map((item: any) => ({
    label: item.name,
    value: item.id,
  }))

  // useEffect(() => {
  //   dispatch(departments.actions.getDepartment())
  // }, [params])
  useEffect(() => {
    dispatch(departments.actions.getDepartmentDropdown())
  }, [])

  useEffect(() => {
    if (success) {
      isEmpty(editSelectedData)
        ? toast.success('Contact Person added successfully')
        : toast.success('Contact Person edited successfully')
      dispatch(contactPersonRedux?.actions?.resetContactPerson())
      dispatch(contactPersonRedux?.actions.getContactPerson(params))
      handleClose()
    }
  }, [success])
  const multiLanguage = checkMultiLanguage()

  return (
    <div className='modal-container'>
      <Modal
        open={open}
        onClose={handleClose}
        className='w-75'
        backdrop='static'
        keyboard={false}
        enforceFocus={false}
        data-cy='modal'
      >
        <Modal.Header>
          <Modal.Title data-cy='modal-title'>{actionType} Contact Person </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Formik
              initialValues={{
                name: '',
                nameNp: '',
                email: '',
                email2: '',
                phone_numbers: [{data: ''}],
                mobile_numbers: [{data: ''}],
                extension: '',
                designation: '',
                image: '',
                departmentid: '',
              }}
              validationSchema={FORM_VALIDATION}
              onSubmit={(values) => {
                const formData = {
                  ...values,
                  mobile_numbers: values?.mobile_numbers[0]?.data ? values?.mobile_numbers : null,
                  phone_numbers: values?.phone_numbers[0]?.data ? values?.phone_numbers : null,
                  email: values?.email ? values?.email : null,
                  email2: values?.email2 ? values?.email2 : null,
                }
                if (!isEmpty(editSelectedData)) {
                  dispatch(
                    contactPersonRedux.actions.updateContactPerson(formData, editSelectedData?.id)
                  )
                } else {
                  dispatch(contactPersonRedux.actions.addContactPerson(formData))
                }
              }}
              data-cy='contact-person-form'
            >
              {({touched, handleChange, errors, values, setFieldValue}) => {
                useEffect(() => {
                  if (!isEmpty(editSelectedData)) {
                    const fields = [
                      'name',
                      'nameNp',
                      'email',
                      'email2',
                      'phone_numbers',
                      'mobile_numbers',
                      'extension',
                      'designation',
                      'image',
                      'departmentid',
                    ]
                    fields.forEach((field) => setFieldValue(field, editSelectedData[field], false))
                    // setFieldValue('departmentid', editSelectedData?.department?.id, false)
                  }
                }, [])

                return (
                  <Form>
                    <div className='card-body border-top pt-5'>
                      <div className='row'>
                        <div className='col-md-6 col-xs-12'>
                          <FormTextBox
                            type='text'
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder={multiLanguage ? 'Enter Name' : 'Enter Name (En)'}
                            label={multiLanguage ? 'Name' : 'Name (EN)'}
                            name='name'
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                            required
                            data-cy='contact-person-text-field'
                          />
                        </div>
                        {multiLanguage ? null : (
                          <div className='col-md-6 col-xs-12'>
                            <FormTextBox
                              type='text'
                              labelClassName='col-md-12'
                              containerClassName='col-md-12'
                              placeholder='Enter Name (NP)'
                              label='Name (NP)'
                              name='nameNp'
                              onChange={handleChange}
                              errors={errors}
                              touched={touched}
                              data-cy='contact-person-name-np-field'
                            />
                          </div>
                        )}

                        <div className='col-md-6 col-xs-12'>
                          <FormTextBox
                            type='text'
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder='Enter E-mail'
                            label='Email'
                            name='email'
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                            data-cy='contact-person-email-field'
                          />
                        </div>

                        <div className='col-md-6 col-xs-12'>
                          <FormTextBox
                            type='text'
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder='Enter E-mail'
                            label='Email (opt)'
                            name='email2'
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                            data-cy='contact-person-email-field'
                          />
                        </div>
                        <div className='col-md-6 col-xs-12'>
                          <FormTextBox
                            type='text'
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder='Enter Designation'
                            label={multiLanguage ? 'Designation ' : 'Designation (EN)'}
                            name='designation'
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                            required
                            data-cy='contact-person-designation-field'
                          />
                        </div>
                        <div className='col-md-6 col-sm-6 col-xs-12'>
                          <FormSelect
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder='Please select Department'
                            label='Department'
                            name='departmentid'
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                            options={departmentOptions}
                            values={values}
                            setFieldValue={setFieldValue}
                            data-cy='contact-person-drop-down-field'
                          />
                        </div>

                        <div className='col-md-6 col-xs-12'>
                          <FieldArray
                            name='mobile_numbers'
                            render={(arrayHelpers) => (
                              <div>
                                {values.mobile_numbers && values.mobile_numbers.length > 0
                                  ? values.mobile_numbers.map((friend: any, index: any) => (
                                      <div key={index}>
                                        {/** both these conventions do the same */}
                                        <FormTextBox
                                          type='text'
                                          labelClassName='col-md-12'
                                          containerClassName='col-md-12'
                                          placeholder='Enter Mobile Number'
                                          label='Mobile Number'
                                          name={`mobile_numbers.${index}.data`}
                                          onChange={handleChange}
                                          errors={errors}
                                          touched={touched}
                                        />
                                        <div className='d-flex justify-content-end mb-3'>
                                          <em>
                                            <small className='d-block'>
                                              <span className='text-danger'>Note: </span> Mobile
                                              number should starts with 98|97
                                            </small>
                                          </em>
                                        </div>
                                        {index > 0 && (
                                          <div className='col-md-12 justify-content-md-end text-end mb-2'>
                                            <button
                                              type='button'
                                              className='p-2 ps-5 pe-5 btn btn-secondary'
                                              onClick={() => arrayHelpers.remove(index)}
                                              data-cy='modal-field-remove'
                                            >
                                              Remove
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                    ))
                                  : null}
                                <div className=' d-flex justify-content-md-end mb-2 border-top border-light'>
                                  <button
                                    className='p-2 ps-5 pe-5 btn btn-primary'
                                    type='button'
                                    onClick={() => arrayHelpers.push({data: ''})}
                                    data-cy='modal-field-add'
                                  >
                                    + Add More
                                  </button>
                                </div>
                              </div>
                            )}
                          />
                        </div>
                        <div className='col-md-6 col-xs-12'>
                          <FieldArray
                            name='phone_numbers'
                            render={(arrayHelpers) => (
                              <>
                                {values.phone_numbers && values.phone_numbers.length > 0
                                  ? values.phone_numbers.map((friend: any, index: any) => (
                                      <div key={index}>
                                        {/** both these conventions do the same */}
                                        <FormTextBox
                                          type='text'
                                          labelClassName='col-md-12'
                                          containerClassName='col-md-12'
                                          placeholder='Enter Phone Number'
                                          label='Phone Number'
                                          name={`phone_numbers.${index}.data`}
                                          onChange={handleChange}
                                          errors={errors}
                                          data-cy='contact-person-phone-number'
                                          touched={touched}
                                        />

                                        {index > 0 && (
                                          <div className='col-md-12  justify-content-md-end text-end mb-2'>
                                            <button
                                              type='button'
                                              className='p-2 ps-5 pe-5 btn btn-secondary'
                                              onClick={() => arrayHelpers.remove(index)}
                                              data-cy='modal-field-remover'
                                            >
                                              Remove
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                    ))
                                  : null}
                                <div className=' d-flex justify-content-md-end mb-2 border-top border-light'>
                                  <button
                                    className='p-2 ps-5 pe-5 btn btn-primary'
                                    type='button'
                                    onClick={() => arrayHelpers.push({data: ''})}
                                    data-cy='modal-field-adds'
                                  >
                                    + Add More
                                  </button>
                                </div>
                              </>
                            )}
                          />
                        </div>
                        <div className='col-md-6 col-sm-6 col-xs-12'>
                          <FormTextBox
                            type='text'
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            placeholder='Extension'
                            label='Extension'
                            name='extension'
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                            data-cy='contact-person-extension-field'
                          />
                        </div>

                        <div className='col-md-6 col-xs-12'>
                          <FormInputMediaManager
                            labelClassName='col-md-12'
                            containerClassName='col-md-12'
                            label='Image'
                            name='image'
                            setFieldValue={setFieldValue}
                            value={values?.image}
                            data-cy='contact-person-image-field'
                          />

                          {!isEmpty(values?.image) ? (
                            <>
                              <li className='listing'>
                                <div className='thumbImageBlock'>
                                  <button
                                    type='button'
                                    title='Remove'
                                    className='btn thumbImage-remove d-flex align-items-center justify-content-center btn-primary'
                                    onClick={() => {
                                      setFieldValue('image', '')
                                    }}
                                    data-cy='contact-person-delete-button'
                                  >
                                    Delete
                                  </button>

                                  <img
                                    className='thumbImage w-100 h-100'
                                    src={`${imageBaseUrl}/${values?.image}`}
                                    alt=''
                                    data-cy='contact-person-thumb-image'
                                  />
                                </div>
                              </li>
                            </>
                          ) : null}
                        </div>
                      </div>

                      <div className='d-flex justify-content-end px-9 '>
                        <button
                          type='submit'
                          disabled={loading}
                          className='btn btn-primary btn-sm ms-3'
                          data-cy='modal-submit'
                        >
                          Save
                        </button>
                        <button
                          type='button'
                          onClick={handleClose}
                          className='btn btn-secondary btn-sm ms-3'
                          data-cy='modal-cancel'
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </Form>
                )
              }}
            </Formik>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}
export default AddContactPerson
